import { useEffect, useState } from 'react';
import useAppStore from '../store';
import { getAgent } from '../lib/api/agents';

/**
 * Single-agent data hook. Store seed first (instant paint from the roster),
 * then GET /api/agents/:id in the background — server row merges by id,
 * keeping the roster's visual fields (icon/role). Server failure is silent
 * here by design: the Agent detail header badge (agentsMode via the page)
 * plus the Memory tab's own badge carry the honesty signal.
 */
function useAgent(id) {
  const agent = useAppStore((state) => (
    state.agents.find((item) => String(item.id) === String(id))
  ));
  const [serverMode, setServerMode] = useState('sample');

  useEffect(() => {
    let cancelled = false;

    getAgent(id)
      .then((row) => {
        if (cancelled || !row) return;
        const store = useAppStore.getState();
        const current = store.agents.find((item) => String(item.id) === String(id));
        if (!current) return;
        store.updateAgent(id, {
          status: row.status ?? current.status,
          progress: row.progress ?? current.progress,
          tasks: row.tasks ?? current.tasks,
          config: row.config ?? current.config,
          budget: row.budget ?? current.budget,
          autonomy: row.autonomy ?? current.autonomy
        });
        setServerMode('live');
      })
      .catch(() => {
        // Keep the roster row; mode stays 'sample'.
        if (!cancelled) setServerMode('sample');
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return {
    agent,
    agentMode: serverMode,
    isLoading: !agent
  };
}

export default useAgent;
